<div class="pending-check-title-area">
    <div class="check-info-header">
        <span class="check-info-label">Projekt:</span>
        <mat-chip>{{ data.checkInfoViewModel()?.project?.displayName ?? '–' }}</mat-chip>
        <mat-icon>chevron_right</mat-icon>
        <span class="check-info-label">Check:</span>
        <mat-chip>{{ data.checkInfoViewModel()?.displayName ?? '–' }}</mat-chip>
        <mat-icon>chevron_right</mat-icon>
        <span class="check-info-label">Status:</span>
        <mat-chip class="status-chip" highlighted>{{ CheckStatus[data.checkInfoViewModel()?.status ?? 0] }}</mat-chip>
        @if (data.checkInfoViewModel()?.isConsultant) {
            <mat-icon>chevron_right</mat-icon>
            <mat-chip class="consultant-badge" highlighted>
                <mat-icon class="consultant-badge-icon">gavel</mat-icon>
                Gutachterliche Tätigkeit
            </mat-chip>
        }
        @if (permission.isInRework()) {
            <mat-icon>chevron_right</mat-icon>
            <mat-chip class="rework-chip" highlighted>
                {{ data.checkInfoViewModel()?.reworkStatus === ReworkStatus.Wiedervorlage ? 'Wiedervorlage' : 'Prüfung nicht möglich' }}
            </mat-chip>
        }
    </div>
    @if (data.checkInfoViewModel()?.status !== CheckStatus['Abgeschlossen'] && !permission.isReadOnly()) {
    <div class="button-area">
        @if (!permission.isInRework()) {
            <!-- Prüfung nicht möglich / Wiedervorlage nur wenn KEIN Rework aktiv und aktiver Prüfer (nicht K1-1) -->
            @if (permission.isCurrentUserActiveChecker() && data.checkInfoViewModel()?.status !== CheckStatus['Kontrolle 1-1']) {
                <button matButton="outlined" (click)="processCheck()">
                     Prüfung nicht möglich</button>
                <button matButton="outlined"
                        [disabled]="!permission.commentsResolved() && !permission.hasOnlyOwnUnresolvedComments()"
                        (click)="confirmWiedervorlage()">
                     Wiedervorlage</button>
            }
            <!-- Weitergeben nur für den aktiven Prüfer der Phase -->
            @if (permission.isCurrentUserActiveChecker()) {
                <button matButton="outlined"
                        [disabled]="!permission.canForwardCheck()"
                        (click)="confirmForwardCheck()">
                    Weitergeben</button>
            }
        } @else {
            <!-- Rework aktiv: checker11 kann Rückläufer erledigen -->
            @if (permission.isCurrentUserChecker11()) {
                <button matButton="outlined"
                        [disabled]="!permission.canResolveRework()"
                        (click)="confirmResolveRework()">
                    Rückläufer erledigt</button>
            }
        }
    </div>
    }
</div>
@if (permission.isInRework()) {
    <div class="rework-info-box">
        <mat-icon class="warn-icon">error</mat-icon>
        <span class="warn-msg">
            @if (data.checkInfoViewModel()?.reworkStatus === ReworkStatus.PruefungNichtMoeglich) {
                <b>Prüfung nicht möglich:</b> Der Prüfer Kontrolle 1-1 ({{ data.checkInfoViewModel()?.checker11?.displayName ?? '–' }}) muss die Gründe bearbeiten und die Pflichtkommentare als erledigt markieren.
            } @else {
                <b>Wiedervorlage:</b> Der Prüfer Kontrolle 1-1 ({{ data.checkInfoViewModel()?.checker11?.displayName ?? '–' }}) muss die offenen Punkte klären, bevor die Prüfung fortgesetzt werden kann.
            }
        </span>
    </div>
}
@if (permission.showForwardedInfoPanel()) {
    <div class="forwarded-info-box">
        <mat-icon class="info-icon">info</mat-icon>
        <span class="info-msg">
            Die Kontrolle wurde weitergegeben.
            <b>{{ permission.activeUserForPhase()?.displayName ?? '–' }}</b>
            ist jetzt als Prüfer für
            <b>{{ CheckStatus[data.checkInfoViewModel()?.status ?? 0] }}</b>
            zuständig.
        </span>
    </div>
}
@if (permission.showCompletedInfoPanel()) {
    <div class="completed-info-box">
        <mat-icon class="info-icon">check_circle</mat-icon>
        <span class="info-msg">
            <b>Der Check ist abgeschlossen.</b> Alle Prüfphasen wurden erfolgreich durchlaufen.
        </span>
    </div>
}

